var _rect, _path, _circle, _ellipse, _ellipse2, _path2, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPvP(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 45,
    fill: "#B5E48C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 75C24 75 30.72 75 50.1333 75M50.1333 75C59.4667 75 63.2 69.8571 63.2 63C63.2 56.1429 70.6667 51 74.4 51H83.7333H108M50.1333 75C59.4667 75 63.2 80.1429 63.2 87C63.2 93.8571 70.6667 99 74.4 99H83.7333H108M50.1333 75H108",
    stroke: "#FEFAE0",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 51,
    r: 9,
    fill: "#FEFAE0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126,
    cy: 75,
    rx: 9,
    ry: 9,
    fill: "#FEFAE0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111,
    cy: 99,
    rx: 9,
    ry: 9,
    fill: "#FEFAE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108 75H124.5",
    stroke: "#FEFAE0",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 75,
    r: 9,
    fill: "#FEFAE0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPvP);
export default __webpack_public_path__ + "static/media/PvP.00ea231da80af57adc4c79f7218bd0b2.svg";
export { ForwardRef as ReactComponent };